import { useState } from "react"
import { useNavigate } from "react-router-dom"
import { UserPlus, UserCog, Briefcase, ChevronDown } from "lucide-react"

import { PageHeader } from "../../common/ui"
import { LOsTableWithImporter } from "../../common/ui/loan-officers"
import Menu from "../../common/ui/menu"
import MenuItem from "../../common/ui/menu/item"
import CreateBrandAdminModal from "../../common/ui/brand-admin/create-brand-admin-modal"
import { RequireRole } from "../../common/validation"
import {
  useAppDispatch,
  useAppSelector,
  useIsSuperAdmin
} from "../../common/hooks"
import { setVisiblePanel } from "../../redux/slices/app"
import { selectUserDetails } from "../../redux/slices/auth"
import { ALLOWED_ROLES_BY_ROUTE } from "../../common/constants"

const LOPage = () => {
  const navigate = useNavigate()
  const dispatch = useAppDispatch()
  const user = useAppSelector(selectUserDetails)
  const [modalOpen, setModalOpen] = useState(false)

  const isSuperAdmin = useIsSuperAdmin()

  const onClickLO = (loanOfficerId: string) => {
    navigate(`/loan-officers/${loanOfficerId}`)
  }

  return (
    <RequireRole allowedRoles={ALLOWED_ROLES_BY_ROUTE["loan-officers"]}>
      <>
        <div className="p-6 bg-white">
          <div className="pb-6">
            <PageHeader title="Loan officers">
              <Menu
                label={
                  <span className="inline-flex items-center gap-2">
                    <UserPlus size={16} />
                    <span>Add User</span>
                    <ChevronDown size={14} className="opacity-70" />
                  </span>
                }
                buttonClassName="inline-flex items-center rounded-md bg-primary-400 hover:bg-primary-600 px-4 py-2 text-sm font-medium text-white shadow-sm transition-colors"
              >
                <MenuItem
                  label="Brand Admin"
                  icon={<UserCog size={16} />}
                  onClick={() => setModalOpen(true)}
                />
                <MenuItem
                  label="Loan Officer"
                  icon={<Briefcase size={16} />}
                  onClick={() => dispatch(setVisiblePanel("loan-officer/new"))}
                />
              </Menu>
            </PageHeader>
          </div>

          <LOsTableWithImporter
            searchParams={{ isSuperAdmin, org_id: user?.org?.id }}
            hasMasqueradeIcon
            onClickLO={onClickLO}
          />
        </div>
        <CreateBrandAdminModal
          open={modalOpen}
          onClose={() => setModalOpen(false)}
        />
      </>
    </RequireRole>
  )
}

export default LOPage
